// Centralized confirm() helper. Future: replace window.confirm with a custom
// modal that supports type-to-confirm for high-risk actions like project delete.

export function confirmAction(message: string): boolean {
  return window.confirm(message)
}

export function confirmDelete(thing: string): boolean {
  return confirmAction(
    `Delete ${thing}? This is permanent — only restorable from the most recent backup.`
  )
}

export function confirmHighRisk(message: string, expected: string): boolean {
  const input = window.prompt(`${message}\n\nType "${expected}" to confirm.`)
  return input === expected
}
